/**
 * Presentación de feriados (008 · T075). Sin reglas: solo texto de lo que devuelve la API.
 */
import type { Holiday } from '@fermin/contracts';

import { t } from '../../../i18n';
import { weekdayShort } from '../format';

/** "Todas las sedes" o el nombre de la sede. */
export function holidayScopeLabel(holiday: Pick<Holiday, 'site'>): string {
  return holiday.site ? holiday.site.name : t('schedules.holidays.scope.company');
}

/** Día ISO (1 = lunes … 7 = domingo) de un `LocalDate`, sin depender de la zona del navegador. */
export function isoWeekday(day: string): number {
  const weekday = new Date(`${day}T00:00:00Z`).getUTCDay();
  return weekday === 0 ? 7 : weekday;
}

/** "mi 08/10/2026". */
export function holidayDayLabel(day: string): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(day);
  if (!match) {
    return day;
  }
  return `${weekdayShort(isoWeekday(day))} ${match[3]}/${match[2]}/${match[1]}`;
}
